export const BRAND = {
  name: "Innovative Preschool",
  tagline: "Serving Early Childhood Development Since 2017",
  positioning: "Nepalese Concept Preschool",
  established: "2017 (2073 BS)",
  location: "Panga, Kirtipur, Nepal",
  address: "Panga, Kirtipur — 05, Kathmandu, Nepal",
  phone: "+977-01-5903752",
  email: "innovativepreschool17@gmail.com",
  facebook: "https://www.facebook.com/InnovativePreschoolPanga/",
  mapEmbed: "https://www.google.com/maps?q=Innovative+Preschool+Panga+Kirtipur&output=embed",
  mapShareUrl: "https://maps.app.goo.gl/ibf9ZybRZgsVSZFJ6",
  logo: "https://customer-assets.emergentagent.com/job_39afe17b-ffda-4a08-8793-85040a1d0e13/artifacts/8lkw7qux_image.png",
  heroBg: "https://customer-assets-lqy194kg.emergentagent.net/job_innovate-preschool/artifacts/zyz6tcfa_2GirlsColoring.jpg",
  aboutIllustration: "https://customer-assets-lqy194kg.emergentagent.net/job_innovate-preschool/artifacts/wh9q3laa_2KidsPlaying.jpg",
};

export const NAV_LINKS = [
  { id: "home", label: "Home", to: "/" },
  { id: "about", label: "About", to: "/about" },
  { id: "philosophy", label: "Philosophy", to: "/philosophy" },
  { id: "programs", label: "Programs", to: "/programs" },
  { id: "gallery", label: "Gallery", to: "/gallery" },
  { id: "testimonials", label: "Testimonials", to: "/testimonials" },
  { id: "calendar", label: "Academic Calendar", to: "/calendar" },
  { id: "admissions", label: "Admissions", to: "/admissions" },
  { id: "contact", label: "Contact", to: "/#contact" },
];
